import { render, staticRenderFns } from "./Focus.vue?vue&type=template&id=6887e654&scoped=true"
import script from "./Focus.vue?vue&type=script&lang=js"
export * from "./Focus.vue?vue&type=script&lang=js"
import style0 from "./Focus.vue?vue&type=style&index=0&id=6887e654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887e654",
  null
  
)

export default component.exports